import React, { useState } from 'react'
import "./Contact.css"
import SectionHeading from '../../utilities/SectionHeading'
import Typical from "react-typical"

import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export default function Contact() {

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");


    function ValidateEmail(mail) {
        const regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        if (regex.test(mail)) {
            return (true) // valid
        }
        return (false)  // not valid
    }

    const sendEmail = (e) => {
        e.preventDefault();

        if (name.length === 0 || email.length === 0 || subject.length === 0 || message.length === 0) {
            toast.error("Please fill all the fields");
            return;
        }
        else if (!ValidateEmail(email)) {
            rejected();
            return;
        }

        emailjs.sendForm('service_b48npyt', 'template_cwmoj16', e.target, 'user_tNb3B3wxXmGUlRcWMgGnb')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        successfullySent();

    };

    const successfullySent = () => {        // The message has been sent successfully
        const resolveAfter3sec = new Promise((resolve, reject) => {
            setTimeout(resolve, 3000);
            setTimeout(() => {
                setName("");
                setEmail("");
                setSubject("");
                setMessage("");
            }, 3000);
        });
        toast.promise(resolveAfter3sec, {
            pending: "Loading ...",
            success: "Successfully sent!"
        });
    };

    const rejected = () => {        // Please enter a valid email address
        const resolveAfter3sec = new Promise((resolve, reject) => {
            setTimeout(reject, 3000);
        });
        toast.promise(resolveAfter3sec, {
            pending: "Loading ...",
            error: "Please enter a valid email address"
        });
    };

    return (
        <div>
            <section id="Contact">

                <div data-aos="fade-out">


                    <SectionHeading heading="Contact Me" description="Let's Keep in Touch" />
                </div>

                <div className="contact-container" data-aos="fade-in">
                    <div className="contact-box">

                        <div className="image-box" data-aos="fade-in">
                            <img src={require("./../../static/contact3.png")} alt="" />
                            <div className='image-footer'>
                                <Typical loop={Infinity} steps={[
                                    "Drop a Message Here!", 3000,
                                    "Follow me on my Social Media", 5000,
                                ]} />
                            </div>
                        </div>


                        <div className="form-box" data-aos="fade-out">

                            <form action="" onSubmit={sendEmail} >
                                <label htmlFor="name" className='myname'>Name
                                    <input type="text" name="from_name" value={name} onChange={(e) => setName(e.target.value)} placeholder='Enter Your Name' />
                                </label>
                                <label htmlFor="email" className='myemail'>Email
                                    <input type="text" name="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder='Enter Your Email' />
                                </label>
                                <label htmlFor="subject" className='mysubject'>Subject
                                    <input type="text" name="subject" value={subject} onChange={(e) => setSubject(e.target.value)} placeholder='Write a Subject' autoComplete='off' />
                                </label>
                                <label htmlFor="message" className='mymessage'>Message
                                    <textarea name="message" value={message} onChange={(e) => setMessage(e.target.value)} cols="24" rows="5" placeholder='Write Your Message'></textarea>
                                </label>
                                <button type="submit">Send</button>
                            </form>

                        </div>


                    </div>
                </div>

                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme='colored'
                />

                {/* =============================  Footer Part  ============================ */}
                <div className="footer">

                    <div className='upperPart'>
                        <div className="contact-email">

                            <img src={require("./../../static/email.png")} alt="" />
                            <div className="mail-details">
                                <h6 className="icon-head">Contact</h6>
                                <a href='mailto:halderarindam10000@gmail.com' className="icon-desc">halderarindam10000@gmail.com</a>
                            </div>

                        </div>

                        <div className="contact-socialMedia">
                            <img src={require("./../../static/plus.png")} alt="" />
                            <div className="media-details">
                                <p className="icon-head connect">Follow Me on</p>
                                <div className="socialMediaIcons2">
                                    <a href="https://www.facebook.com/arindam363" target="_blank" rel="noopener noreferrer"> <i className="fa fa-facebook-square" id="fb"></i> </a>
                                    <a href="https://www.instagram.com/arindam369/" target="_blank" rel="noopener noreferrer"> <i className="fa fa-instagram" id="insta"></i> </a>
                                    <a href="https://twitter.com/Arindam87777" target="_blank" rel="noopener noreferrer"> <i className="fa fa-twitter-square" id="twitter"></i> </a>
                                    <a href="https://www.linkedin.com/in/arindam369/" target="_blank" rel="noopener noreferrer"> <i className="fa fa-linkedin" id="linkedin"></i> </a>
                                    <a href="https://github.com/arindam369" target="_blank" rel="noopener noreferrer"> <i className="fa fa-github" id="github"></i> </a>
                                </div>
                            </div>
                        </div>

                        <div className="copyright">
                            <img src={require("./../../static/copyright.png")} alt="" />
                            <p className='copyright-name'> Arindam Halder | 2022 </p>
                        </div>
                    </div>

                    <div className="copyright2">
                        <img src={require("./../../static/copyright.png")} alt="" />
                        <p className='copyright-name'> Arindam Halder | 2022 </p>
                    </div>

                </div>
            </section>
        </div>
    )
}
